// Simple map utilities for TSP

export const pathToGeoJSON = (pathData, locations) => {
  if (!pathData || !Array.isArray(pathData) || pathData.length < 2) {
    return {
      type: 'FeatureCollection',
      features: []
    };
  }

  let coordinates;
  
  // Handle different path data formats
  if (pathData[0] && typeof pathData[0] === 'object' && pathData[0].lng !== undefined) {
    // Direct coordinate objects with lng/lat
    coordinates = pathData
      .filter(point => point && typeof point.lng === 'number' && typeof point.lat === 'number')
      .map(point => [point.lng, point.lat]);
  } else if (pathData[0] && typeof pathData[0] === 'string' && locations) {
    // Location IDs - need to resolve to coordinates
    coordinates = pathData
      .map(id => locations.find(loc => loc.id === id))
      .filter(loc => loc && typeof loc.longitude === 'number' && typeof loc.latitude === 'number')
      .map(loc => [loc.longitude, loc.latitude]);
  } else {
    return {
      type: 'FeatureCollection',
      features: []
    };
  }

  if (coordinates.length < 2) {
    return {
      type: 'FeatureCollection', 
      features: []
    };
  }

  return {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: coordinates
      },
      properties: {}
    }]
  };
};
